angular.module("avant.customer_applications.controllers").controller "SectionMixinCtrl", [
  "$scope", "$timeout", "$window", "$document", "$rootScope",
  ($scope, $timeout, $window, $document, $rootScope) ->

    $scope.toggleSection = (section, visible) ->
      $rootScope.$broadcast("section_visibility:#{$scope.page}:#{section}", visible)

    $scope.lastSnapIndex = 0
    # config for snap-scroll directive
    $scope.snapIndex = 0
    $scope.snapHeight = $window.innerHeight
    $scope.snapAnimation = true

    $scope.sectionFieldsAttemptedToSubmit = []
    $scope.activeSectionConfig = {}
    $scope.broadcastSectionConfig = true

    $scope.scopeIndexMax = ->
      $scope.page_requirements.length - 1

    $scope.beforeSnap = (data) ->
      data.snapIndex <= $scope.lastSnapIndex

    $scope.afterSnap = (data) ->
      $scope.sectionFieldsAttemptedToSubmit = []
      if $scope.broadcastSectionConfig
        $scope.$broadcast "new_active_section_config", $scope.activeSectionConfig
      else
        $scope.broadcastSectionConfig = true

    $scope.setSnapIndex = (snap_index) ->
      if $scope.snapIndex == snap_index
        # Return to bottom of application for users who scrolled up manually
        $scope.broadcastSectionConfig = false
        $timeout ->
          $scope.snapIndex = null
      else
        $scope.lastSnapIndex = _.max([$scope.lastSnapIndex, snap_index])
        $scope.snapIndex = snap_index


    $scope.scrollToSectionConfig = (section_config) ->
      $scope.blurActiveElement()
      $scope.activeSectionConfig = section_config
      $scope.setSnapIndex _.max([_.findIndex($scope.page_requirements, section_config), 0])

    $scope.firstIncompleteSection = ->
      _.find($scope.page_requirements, (section_config) ->
        complete = $scope.sectionComplete(section_config)
        $scope.toggleSection(section_config.section, true)
        !complete
      )

    $scope.optionClicked = (section_string, ivar, property, value) ->
      $scope[ivar][property] = value
      $scope.update "#{ivar}.#{property}"
      ($timeout -> $scope.submitSection section_string) if section_string?

    $scope.isOptionSelected = (ivar, property, value) ->
      $scope[ivar]?[property] == value

    $scope.blurActiveElement = ->
      if $document[0].activeElement?
        $document[0].activeElement.blur()

    $scope.submitSection = (section_string) ->
      submitted_section = $scope.sectionStringToConfig(section_string)
      submitted_section.submitted = true
      first_incomplete = $scope.firstIncompleteSection()
      first_incomplete_index = _.findIndex($scope.page_requirements, first_incomplete)
      next_section_index = _.findIndex($scope.page_requirements, { section: section_string }) + 1
      next_section_index = _.min([next_section_index, $scope.page_requirements.length - 1])
      lowest_index = _.min([next_section_index, first_incomplete_index])
      visible_section_config = $scope.page_requirements[lowest_index]
      $scope.scrollToSectionConfig(visible_section_config)

    sectionNameIfSubmittedRequiredFields = ->
      result = null
      return result if $scope.sectionFieldsAttemptedToSubmit.length is 0
      _.some($scope.page_requirements, (section_config) ->
        match_in_section = false
        _.each(section_config.fields, (fields, ivar) ->
          _.each(fields, (field_config, field) ->
            match = _.findWhere($scope.sectionFieldsAttemptedToSubmit, { ivar: ivar, field: field })
            if match?
              match_in_section = true
          )
        )
        if match_in_section && $scope.allFieldsInSectionComplete(section_config)
          result = section_config
          true
        else
          false
      )
      result?.section

    $scope.$on "input_keypress:enter", (event, data) ->
      unless _.findWhere($scope.sectionFieldsAttemptedToSubmit, data)
        $scope.sectionFieldsAttemptedToSubmit.push(data)
      section_name = sectionNameIfSubmittedRequiredFields()
      if section_name?
        $scope.submitSection section_name

    $scope.loadLastSection = ->
      first_incomplete = $scope.firstIncompleteSection()
      $scope.scrollToSectionConfig(first_incomplete)

    $scope.sectionStringToConfig = (section_string) ->
      _.findWhere($scope.page_requirements, { section: section_string })

    $scope.isSubmittableSection = (section_string) ->
      section_config = $scope.sectionStringToConfig(section_string)
      $scope.allFieldsInSectionComplete(section_config)
      
    $scope.sectionComplete = (section_config) ->
      section_config.submitted is true && $scope.allFieldsInSectionComplete(section_config)

    $scope.allFieldsInSectionComplete = (section_config) ->
      _.every(section_config.fields, (fields, ivar) ->
        _.every(fields, (field_config, field) ->
          form_field = $scope.form["#{ivar}_#{field}"]
          !form_field || form_field.$valid
        )
      )

    $scope.attemptToLoadSections = ->
      if _.every($scope.page_requirements, (section_config) -> section_config.loaded is true)
        $timeout ->
          $scope.loadLastSection()

    $scope.$on "app_field_loaded:#{$scope.page}", (event, section_config) ->
      section_config.loaded = true
      $scope.attemptToLoadSections()
]
